import { browseServiceChips } from "@/lib/browseLocation";

/** Horizontally scrollable service/keyword chips with a soft right-edge fade. */
export default function BrowseServiceChips({ branch, limit = 8, testId }) {
  const chips = browseServiceChips(branch, limit);
  if (!chips.length) return null;
  return (
    <div className="relative mt-2" data-testid={testId || `service-chips-${branch?.id}`}>
      <div className="flex gap-1.5 overflow-x-auto pb-0.5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {chips.map((label) => (
          <span
            key={label}
            className="shrink-0 rounded-full border border-border bg-secondary/60 px-2 py-0.5 text-[11px] font-medium text-muted-foreground"
          >
            {label}
          </span>
        ))}
      </div>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-card to-transparent"
      />
    </div>
  );
}
